import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

const ForumHeading = ({ description, title }) => (
  <div className="mx-4 mb-4 lg:mx-0">
    <Heading as="h1" className="md:pt-6" size="size3">
      {title}
    </Heading>
    <Text className="pt-2">{description}</Text>
  </div>
);

ForumHeading.propTypes = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default ForumHeading;
